import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { CommonTaskStatus } from '@euler/model/enum';
import { Check, Hourglass, Loader, Minus } from 'lucide-react-native';
import { memo } from 'react';
import { View } from 'react-native';
import { TIMED_OUT, TOKENS, kStepCircleSize } from '../constants';
import { StepStatus } from '../types';

export const StepCircle = memo(
  ({
    status,
    timedOut,
    historyMode,
  }: {
    status: StepStatus;
    timedOut?: boolean;
    historyMode?: boolean;
  }) => {
    const { rpx } = useResponsiveContext();
    const size = rpx(kStepCircleSize);
    const iconSize = rpx(11);
    const pendingBg = timedOut ? TIMED_OUT.stepPendingBg : TOKENS.stepPendingBg;
    const PendingIcon = historyMode ? Minus : Hourglass;

    if (status === CommonTaskStatus.Finished) {
      return (
        <View
          css={`
            width: ${size}px;
            height: ${size}px;
            border-radius: ${size}px;
            background-color: ${TOKENS.stepFinishedBg};
            align-items: center;
            justify-content: center;
          `}
        >
          <Check size={iconSize} color="#fff" strokeWidth={3} />
        </View>
      );
    }
    if (status === CommonTaskStatus.InProgress) {
      return (
        <View
          css={`
            width: ${size}px;
            height: ${size}px;
            border-radius: ${size}px;
            border-width: ${rpx(1.5)}px;
            border-color: ${TOKENS.stepInProgressText};
            background-color: #fff;
            align-items: center;
            justify-content: center;
          `}
        >
          <Loader
            size={iconSize}
            color={TOKENS.stepInProgressText}
            strokeWidth={2.5}
          />
        </View>
      );
    }
    return (
      <View
        css={`
          width: ${size}px;
          height: ${size}px;
          border-radius: ${size}px;
          background-color: ${pendingBg};
          align-items: center;
          justify-content: center;
        `}
      >
        <PendingIcon size={iconSize} color="#ffffff" strokeWidth={2} />
      </View>
    );
  },
);
